<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M5.5 5.5l13 13M18.5 5.5l-13 13"/>
</svg>
